<template>
  <el-form class="formItem-container" :model="queryForm" ref="queryForm">
    <el-form-item class="r-20" v-show="'iphone' in queryForm" prop="iphone">
      <el-input
        v-model.trim="queryForm.iphone"
        @keyup.enter.native="query"
        placeholder="手机号"
      ></el-input>
    </el-form-item>
    <el-form-item
      class="r-20"
      v-show="typeList.length !== 0"
      prop="applicationName"
    >
      <el-select
        v-model="queryForm.applicationName"
        clearable
        filterable
        placeholder="应用名称"
      >
        <el-option
          v-for="item in typeList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
    </el-form-item>

    <el-form-item
      class="r-20"
      v-show="stationTypeList.length !== 0"
      prop="stationType"
    >
      <el-select
        v-model="queryForm.stationType"
        clearable
        filterable
        placeholder="站址类型"
      >
        <el-option
          v-for="item in stationTypeList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
    </el-form-item>

    <el-form-item class="r-20" v-show="'plate' in queryForm" prop="plate">
      <el-input
        v-model.trim="queryForm.plate"
        @keyup.enter.native="query"
        placeholder="车牌号"
      ></el-input>
    </el-form-item>

    <el-form-item class="r-20" v-show="'phone' in queryForm" prop="phone">
      <el-input
        v-model.trim="queryForm.phone"
        @keyup.enter.native="query"
        placeholder="车主账号"
      ></el-input>
    </el-form-item>
    <el-form-item
      class="r-20"
      v-show="'stationName' in queryForm"
      prop="stationName"
    >
      <el-input
        v-model.trim="queryForm.stationName"
        @keyup.enter.native="query"
        placeholder="基站名称"
      ></el-input>
    </el-form-item>

    <el-form-item
      class="r-20 picker-item"
      v-for="(item, index) in pickerList"
      :key="index"
      prop="startTime"
    >
      <el-col :span="11">
        <el-date-picker
          type="date"
          value-format="yyyy-MM-dd"
          v-model="queryForm.startTime"
          :placeholder="item.start"
          style="width: 260px"
          :picker-options="startDatePicker"
        ></el-date-picker>
      </el-col>
      <el-col class="line" :span="2">-</el-col>
      <el-col :span="11">
        <el-date-picker
          type="date"
          v-model="queryForm.endTime"
          value-format="yyyy-MM-dd"
          :placeholder="item.end"
          style="width: 260px"
          :picker-options="endDatePicker"
        ></el-date-picker>
      </el-col>
    </el-form-item>

    <el-button size="medium" type="primary" @click="query">查询</el-button>
    <el-button size="medium" @click="reset">取消</el-button>
  </el-form>
</template>

<script>
//  pickerList: [{ start: "开始时间", end: "结束时间" }], 请传一个数组对象
export default {
  name: "FormItem",
  props: {
    prop: {
      type: String,
      default: "",
    },
    queryForm: {
      type: Object,
      default: () => {},
    },
    pickerList: {
      type: Array,
      default: () => [],
    },
    typeList: {
      type: Array,
      default: () => [],
    },
    stationTypeList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      startDatePicker: this.expireTimeOptionStart(),
      endDatePicker: this.expireTimeOptionEnd(),
    };
  },
  computed: {
    // filterFormList: function () {
    //   return this.formList.filter((item) => item.type === "no-connection");
    // },
  },
  mounted() {},
  methods: {
    // 日期选择器规则
    expireTimeOptionStart() {
      // 当结束时间不为空时，开始时间早于结束时间
      return {
        disabledDate: (time) => {
          if (this.queryForm.endTime) {
            return time.getTime() > new Date(this.queryForm.endTime).getTime();
          } else {
            return time.getTime() > Date.now(); //结束时间不选时，结束时间最大值小于等于当天
          }
        },
      };
    },
    expireTimeOptionEnd() {
      // 当开始时间不为空时，结束时间要晚于开始时间
      return {
        disabledDate: (time) => {
          if (this.queryForm.startTime) {
            return (
              time.getTime() < new Date(this.queryForm.startTime).getTime() - 8.64e7 ||
              time.getTime() > Date.now()
            );
          } else {
            return time.getTime() > Date.now(); //开始时间不选时，结束时间最大值小于等于当天
          }
        },
      };
    },
    query() {
      this.$emit("query", this.queryForm);
    },
    reset() {
      // 手动重置结束时间数据
      this.queryForm.endTime = "";
      this.$resetForm(this, "queryForm");
      this.$emit("interfaceReset", {
        phone: this.queryForm.phone,
        plate: this.queryForm.plate,
        stationName: this.queryForm.stationName,
        startTime: this.queryForm.startTime,
        endTime: this.queryForm.endTime,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.formItem-container {
  display: flex;
  flex-wrap: wrap;
  .picker-item {
    ::v-deep .el-form-item__content {
      width: 540px;
    }
    .line {
      width: 16px;
      margin-left: 18px !important;
    }
  }
}
/** 日期选择器默认图标样式修改开始 **/
::v-deep .el-input__prefix {
  left: auto;
  right: 10px;
  color: #333;
}
::v-deep .el-icon-arrow-up:before {
  font-weight: 600;
  color: #333;
}
::v-deep .el-select .el-input.is-focus .el-input__inner {
  border-color: #333 !important;
}
::v-deep .el-select .el-input__inner:focus {
  border-color: #333 !important;
}
::v-deep .el-input__inner {
  padding-left: 15px;
}
::v-deep .el-date-editor.el-input {
  width: 100%;
}

/** 日期选择器默认图标样式修改结束 **/
</style>
